<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" :activeon="activeon">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="物流单号">
              <a-input v-model.trim="queryParam.logisticsNo" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="车号">
              <a-input v-model.trim="queryParam.vehicleNo" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="卡号">
                <a-input v-model.trim="queryParam.cardNo" placeholder="请输入" />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="业务类型">
                <a-select v-model="queryParam.businessTypeId" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in businessTypeSelect"
                    :key="index"
                    :value="item.id"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item
                label="创建时间"
                :labelCol="{lg: {span: 7}, sm: {span: 7}}"
                :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              >
                <a-range-picker
                  v-model="queryParam.time"
                  :disabledDate="disabledDate"
                  style="width: 100%"
                  :ranges="{ '今天': [moment().startOf('day'), moment().endOf('day')], '本月': [moment().startOf('month'),  moment().endOf('day')] }"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态">
                <a-select
                  v-if="statusSelect"
                  @change="changeMsg($event)"
                  v-model="queryParam.status"
                  ref="statusSelect"
                  placeholder="请选择"
                >
                  <a-select-option
                    v-for="(item, index) in statusSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="类型">
                <a-select
                  v-if="typeSelect"
                  @change="changeMsg($event)"
                  v-model="queryParam.type"
                  ref="typeSelect"
                  placeholder="请选择"
                >
                  <a-select-option value="999">未收卡</a-select-option>
                  <a-select-option
                    v-for="(item, index) in typeSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <!-- <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button> -->
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
      <!-- <a-button style="margin-left: 0px" type="primary" @click="handleExport()">导出</a-button>-->
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1100 }"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleDetail(record)">详情</a>
        <a-divider type="vertical" />
        <a @click="handleCancellation(record)" v-if="record.grantTime!=null && record.lstatus<100">作废</a>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { STable } from '@/components'
import { grantCardPage, grantCardDelete, grantCardCancellation, grantCardExport } from '@/api/logistics'
import { codeList } from '../../api/sys'
import { formatDate } from '@/utils/date'
import moment from 'moment'
import storage from '@/utils/storage'
import queryMixin from '@/mixins/queryMixin'
  import { getLogStatusTextByValue } from '@/utils/util'

export default {
  name: 'GrantCard',
  mixins: [queryMixin],
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: null,
      // 强制重新渲染参数
      activeon: 1,
      bizCodeList: {},
      // 表头
      columns: [
        {
          title: '物流单号',
          dataIndex: 'logisticsNo',
          width: '200px',
          fixed: 'left'
        },
        {
          title: '车号',
          dataIndex: 'vehicleNo',
          width: '130px'
        },
        {
          title: '卡号',
          dataIndex: 'cardNo',
          width: '130px'
        },
        // {
        //   title: '驾驶员',
        //   dataIndex: 'driverName',
        //   width: '130px'
        // },
        {
          title: '业务类型',
          dataIndex: 'businessTypeName',
          width: '130px'
        },
        // {
        //   title: '卡类型',
        //   dataIndex: 'cardTypeName',
        //   width: '120px'
        // },
        // {
        //   title: '收/发卡',
        //   dataIndex: 'typeName',
        //   width: '100px'
        // },
        // {
        //   title: '状态',
        //   dataIndex: 'statusName',
        //   width: '100px'
        // },
         {
          title: '发卡时间',
          dataIndex: 'grantTime',
          width: '200px',
          customRender: text => {
            let date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '收卡时间',
          dataIndex: 'recoveryTime',
          width: '200px',
          customRender: text => {
            let date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   width: '200px',
        //   customRender: text => {
        //     let date = new Date(text)
        //     return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
        //   }
        // },
        {
          title: '操作',
          width: '130px',
          fixed: 'right',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        // 日期处理
        if (this.queryParam.time !== undefined && this.queryParam.time.length > 1) {
          this.queryParam['startTime'] = formatDate(new Date(this.queryParam.time[0]), 'yyyy-MM-dd hh:mm:ss')
          this.queryParam['endTime'] = formatDate(new Date(this.queryParam.time[1]), 'yyyy-MM-dd hh:mm:ss')
        } else {
          this.queryParam['startTime'] = null
          this.queryParam['endTime'] = null
        }

        return grantCardPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // 类型下拉数据
      typeSelect: null,
      // 状态下拉数据
      statusSelect: null,
      businessTypeSelect: null,

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelectData()
     this.bizCodeList = this.$store.getters.bizCodeList
    // 初始化查询条件
    if (!this.queryParam){
      this.queryParam =  {'type':'999', 'status':'1','time': [moment().startOf('day'), moment().endOf('day')]}
    }else{
      if (this.queryParam.time.length >0){
        this.queryParam.time[0] = moment(this.queryParam.time[0])
        this.queryParam.time[1] = moment(this.queryParam.time[1])
      }
    }
   /*  this.queryParam['type'] = '999'
    this.queryParam['status'] = '1'
    this.queryParam['time'] = [moment().startOf('day'), moment().endOf('day')] */
  },
  updated() {},

  methods: {
    moment,
     disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day')
    },
    loadSelectData() {
      // 从后台拉取下拉列表数据
      new Promise(resolve => {
        const data = codeList({ typeCode: 'logistics_grant_card_type' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.typeSelect = res
      })
      new Promise(resolve => {
        const data = codeList({ typeCode: 'logistics_grant_card_status' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.statusSelect = res
      })
      this.businessTypeSelect = this.$store.getters.bizList
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleCancellation(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要作废吗?',
        onOk() {
          return grantCardCancellation({ cardNo: record.cardNo })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    handleDetail(record) {
      storage.save('cache-GrantCardDetail', JSON.stringify(record))
      this.$router.push({ name: 'GrantCardDetail' })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    changeMsg(e) {
      // 触发重新渲染
      this.activeon++
    }
  }
}
</script>
